export default "__VITE_ASSET__R_94iFit__"